export default "__VITE_ASSET__yC1m6mea__"